(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.Slideshow__Slide').forEach((slide) => {
    const destinationUrl = slide.getAttribute('data-destination-url');
    if (destinationUrl) {
      const linkWrapper = document.createElement('a');
      linkWrapper.href = destinationUrl;
      while (slide.firstChild) {
        linkWrapper.appendChild(slide.firstChild);
      }
      slide.appendChild(linkWrapper);
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
